import { ObjectHelper } from "@swivl-mono/helpers";
import { AvailableMembersMap, NotificationBaseInterface, OnlineRosterEntry, SessionInterface, UserInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/notifications/src/API/Events/Events.Controller.ts
export class EventsAPI {
  static async broadcastAvailableMembers(orgId: number, availableMembersMap: AvailableMembersMap): Promise<boolean> {
    return APIService.Notifications.post<boolean>(`/events/org/${orgId}/available-members`, availableMembersMap);
  }
  static async broadcastSessionUpdate(orgId: number, session: Partial<SessionInterface>): Promise<boolean> {
    return APIService.Notifications.post<boolean>(`/events/org/${orgId}/type/session`, ObjectHelper.stripNulls(session));
  }
  static async broadcastEscalation(orgId: number, escalation: Partial<SessionInterface>): Promise<boolean> {
    return APIService.Notifications.post<boolean>(`/events/org/${orgId}/type/escalation`, ObjectHelper.stripNulls(escalation));
  }
  static async broadcastNotification(orgId: number, notification: NotificationBaseInterface): Promise<boolean> {
    return APIService.Notifications.post<boolean>(`/events/org/${orgId}/type/notification`, ObjectHelper.stripNulls(notification));
  }
  static async broadcastVars(userId: number, vars: { [key: string]: string | undefined }): Promise<boolean> {
    return APIService.Notifications.post<boolean>(`/events/org/${userId}/type/vars/user/${userId}`, vars);
  }
  static async broadcastUsersOnline(orgId: number, onlineUsers: { [userId: number]: OnlineRosterEntry }): Promise<boolean> {
    return APIService.Notifications.post<boolean>(`/events/org/${orgId}/type/users-online`, onlineUsers);
  }
  static async broadcastUserUpdated(orgId: number, userId: number, userData: Partial<UserInterface>): Promise<boolean> {
    return APIService.Notifications.post<boolean>(`/events/org/${orgId}/type/user/${userId}`, userData);
  }
}
